module.exports = __webpack_public_path__ + "static/img/xuanchuangpian.48d92f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xuanchuangpian.png
// module id = LXuR
// module chunks = 1